import { closedSettlementListInputSchema, closedSettlementAuditInputSchema, reviewClosedSettlementInputSchema, type ClosedSettlement, type ClosedSettlementAuditResult } from '@yahshi/contracts';
import type { M2UserApi } from './M2UserApi';
import { M1ApiError } from '../../m1-app/data/M1AppApi';

export function createDevelopmentClosedSettlementApi(seed: ClosedSettlement[] = [], actor = 'admin-demo'): Pick<M2UserApi, 'listClosedSettlements' | 'listClosedSettlementAudit' | 'reviewClosedSettlement'> {
  const cases = structuredClone(seed);
  const audits = new Map<string, ClosedSettlementAuditResult['items']>();
  const mutations = new Map<string, {input: string; result: ClosedSettlement}>();
  return {
    async listClosedSettlements(raw) {
      const input = closedSettlementListInputSchema.parse(raw);
      const filtered = cases.filter(c => (input.status === 'all' || c.status === input.status) && (!input.userId || c.userId === input.userId))
        .sort((a,b) => b.updatedAt.localeCompare(a.updatedAt) || a.id.localeCompare(b.id));
      return structuredClone({items: filtered.slice((input.page-1)*input.pageSize,input.page*input.pageSize),total:filtered.length});
    },
    async listClosedSettlementAudit(raw) {
      const input = closedSettlementAuditInputSchema.parse(raw); const rows = audits.get(input.caseId) ?? [];
      return structuredClone({items:rows.slice((input.page-1)*input.pageSize,input.page*input.pageSize), total:rows.length});
    },
    async reviewClosedSettlement(raw) {
      const input = reviewClosedSettlementInputSchema.parse(raw); const key=JSON.stringify(input); const prior=mutations.get(input.mutationId);
      if (prior) {
        if (prior.input !== key) throw new M1ApiError('M2_SETTLEMENT_IDEMPOTENCY','操作编号已用于不同内容，请重新发起');
        return structuredClone(prior.result);
      }
      const c = cases.find(c => c.id === input.caseId);
      if (!c) throw new M1ApiError('M2_SETTLEMENT_NOT_FOUND','处理单不存在');
      if (c.version !== input.version) throw new M1ApiError('M2_SETTLEMENT_STALE','处理单已更新，请刷新后重新复核');
      if (input.decision === 'reconcile') {
        if (c.status !== 'reviewing') throw new M1ApiError('M2_SETTLEMENT_TRANSITION','请先开始复核');
        if (c.reviewer === actor) throw new M1ApiError('M2_SETTLEMENT_SECOND_REVIEWER','请由另一位管理员确认对账完成');
        if (c.blockers.length || c.debts.length) throw new M1ApiError('M2_SETTLEMENT_BLOCKED','仍有欠账、剩余权益或未结业务，不能确认对账完成');
        if (c.reviewChanged) throw new M1ApiError('M2_SETTLEMENT_CHANGED','复核后的账务已变化，请重新开始复核');
        c.status='reconciled';
      } else if (input.decision === 'start_review') {
        if (c.status === 'reconciled') throw new M1ApiError('M2_SETTLEMENT_TRANSITION','当前状态不允许此操作');
        c.status='reviewing';c.reviewer=actor;c.reviewChanged=false;
      }
      c.version++;c.updatedAt=new Date().toISOString();
      audits.set(c.id,[{id:crypto.randomUUID(),action:input.decision,actor,reason:input.reason,sourceKey:null,createdAt:c.updatedAt,snapshot:{debts:structuredClone(c.debts),blockers:[...c.blockers],refundFingerprint:'local-simulation'}},...(audits.get(c.id) ?? [])]);
      mutations.set(input.mutationId,{input:key,result:structuredClone(c)});
      return structuredClone(c);
    },
  };
}
